import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	uploading: {
		id: 'project-create-importer-upload-flow.common.upload-button.uploading-non-final',
		defaultMessage: 'Uploading...',
		description: 'Uploading spinner text',
	},
	uploaded: {
		id: 'project-create-importer-upload-flow.common.upload-button.uploaded-non-final',
		defaultMessage: 'Uploaded',
		description: 'Uploaded text',
	},
	sizeError: {
		id: 'project-create-importer-upload-flow.common.upload-button.size-error-non-final',
		defaultMessage:
			'This file exceeds the maximum file size of {size} MB. Upload a smaller file to proceed.',
		description: 'Size error message',
	},
	failed: {
		id: 'project-create-importer-upload-flow.common.upload-button.failed-non-final',
		defaultMessage: 'There was a problem while uploading your file. Try again.',
		description: 'Upload failed error message',
	},
	close: {
		id: 'project-create-importer-upload-flow.common.upload-button.close-non-final',
		defaultMessage: 'Cancel',
		description: 'Cancel button label',
	},
});
